$(document).ready(function(){
  var SUPABASE_URL = "https://gbfaazkjmkuqkifexivw.supabase.co";
  var SUPABASE_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdiZmFhemtqbWt1cWtpZmV4aXZ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyNTE1MTAsImV4cCI6MjA5MjgyNzUxMH0.OSR5bzmgSJWJffu377ypnSrPmkRTP94gXeeIolod9ps";
  var PAGE_SIZE = 5;
  var currentRating = "all";
  var currentSort   = "newest";
  var currentPage = 1;
  var totalPages = 1;

  var SORT_ORDER = {
    newest:  "date_created.desc",
    oldest:  "date_created.asc",
    popular: "votes.desc",
  };

  var $reviewsEl   = $("#supa-reviews-list");
  var lang         = ($reviewsEl.attr("data-lan") || "de").toLowerCase();
  var langNeeded   = ($reviewsEl.attr("data-lang-needed") || lang).toLowerCase();
  var TRANS_TITLE  = "translated_" + lang + "_title";
  var TRANS_TEXT   = "translated_" + lang + "_comments";

  var TIME = {
    justNow:      $reviewsEl.attr("data-time-just-now")       || "Just now",
    oneMinuteAgo: $reviewsEl.attr("data-time-one-minute-ago") || "1 minute ago",
    minutesAgo:   $reviewsEl.attr("data-time-minutes-ago")    || "$1 minutes ago",
    oneHourAgo:   $reviewsEl.attr("data-time-one-hour-ago")   || "1 hour ago",
    hoursAgo:     $reviewsEl.attr("data-time-hours-ago")      || "$1 hours ago",
    yesterday:    $reviewsEl.attr("data-time-yesterday")      || "Yesterday",
    daysAgo:      $reviewsEl.attr("data-time-days-ago")       || "$1 days ago",
    oneWeekAgo:   $reviewsEl.attr("data-time-one-week-ago")   || "1 week ago",
    weeksAgo:     $reviewsEl.attr("data-time-weeks-ago")      || "$1 weeks ago",
    oneMonthAgo:  $reviewsEl.attr("data-time-one-month-ago")  || "1 month ago",
    monthsAgo:    $reviewsEl.attr("data-time-months-ago")     || "$1 months ago",
    oneYearAgo:   $reviewsEl.attr("data-time-one-year-ago")   || "1 year ago",
    yearsAgo:     $reviewsEl.attr("data-time-years-ago")      || "$1 years ago",
  };

  var productGroup  = $reviewsEl.attr("data-product-group") || "RGroup_HPro";

  var BTN_TRANSLATE = $reviewsEl.attr("data-btn-translate") || "Translate";
  var BTN_REVERT    = $reviewsEl.attr("data-btn-revert")    || "Show original";
  var BTN_LOADING   = $reviewsEl.attr("data-btn-loading")   || "Translating…";
  var WAS_HELPFUL     = $reviewsEl.attr("data-was-helpful")     || "Was this review helpful?";
  var UPVOTED         = $reviewsEl.attr("data-trans-upvoted")   || "Thank you!";
  var NO_COMMENTS     = $reviewsEl.attr("data-no-comments")     || "";
  var VERIFIED_BUYER  = $reviewsEl.attr("data-verified-buyer")  || "Verified Buyer";

  var TRANSLATE_ICON = "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/Translate.png?v=1774862712";

  var TRANSLATE_BTNS_HTML =
    '<div class="rsp_popup-translate_btns">' +
      '<div class="rsp_popup-translate-btn">' +
        '<div class="review_lan-btn_in">' +
          '<span><img src="' + TRANSLATE_ICON + '"></span>' +
          '<span><p>' + BTN_TRANSLATE + '</p></span>' +
        '</div>' +
      '</div>' +
      '<div class="rsp_popup-revert-btn">' +
        '<div class="review_lan-btn_in">' +
          '<span><img src="' + TRANSLATE_ICON + '"></span>' +
          '<span><p>' + BTN_REVERT + '</p></span>' +
        '</div>' +
      '</div>' +
      '<div class="rsp_popup-loading-btn">' +
        '<span>' + BTN_LOADING + '</span>' +
        '<span class="review_loading-loader"></span>' +
      '</div>' +
    '</div>';

  var PLAY_ICON_SVG =
    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="24" cy="24" r="24" fill="rgba(0,0,0,0.5)"/>' +
      '<polygon points="17,13 37,24 17,35" fill="white"/>' +
    '</svg>';

  var POPUP_PLAY_ICON_SVG =
    '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="32" cy="32" r="32" fill="rgba(0,0,0,0.5)"/>' +
      '<polygon points="23,17 46,32 23,47" fill="white"/>' +
    '</svg>';

  var STAR_IMGS = {
    5: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars5.png?v=1778831784",
    4: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars4.png?v=1778831784",
    3: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars3.png?v=1778831783",
    2: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars2.png?v=1778831784",
    1: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars1.png?v=1778831784",
  };
  var BADGE_ICON =
    "https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Group_505548.png?v=1757337931";

  var SUPABASE_HEADERS = {
    apikey: SUPABASE_KEY,
    Authorization: "Bearer " + SUPABASE_KEY,
  };

  function thumbUrl(src) {
    return "https://media.reviews.co.uk/resize/create?format=jpg&width=400&height=400&src=" + encodeURIComponent(src);
  }

  function timeAgo(dateStr) {
    if (!dateStr) return "";
    var diff = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
    if (diff < 60)  return TIME.justNow;
    var m = Math.floor(diff / 60);
    if (m < 60)     return m === 1 ? TIME.oneMinuteAgo : TIME.minutesAgo.replace("$1", m);
    var h = Math.floor(diff / 3600);
    if (h < 24)     return h === 1 ? TIME.oneHourAgo   : TIME.hoursAgo.replace("$1", h);
    var d = Math.floor(diff / 86400);
    if (d < 7)      return d === 1 ? TIME.yesterday     : TIME.daysAgo.replace("$1", d);
    var w = Math.floor(d / 7);
    if (w < 5)      return w === 1 ? TIME.oneWeekAgo   : TIME.weeksAgo.replace("$1", w);
    var mo = Math.floor(d / 30);
    if (mo < 12)    return mo === 1 ? TIME.oneMonthAgo  : TIME.monthsAgo.replace("$1", mo);
    var yr = Math.floor(d / 365);
    return yr === 1 ? TIME.oneYearAgo : TIME.yearsAgo.replace("$1", yr);
  }

  function escapeAttr(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;");
  }

  function getImages(r) {
    var imgSrc = r.published_images || r.unpublished_images || "";
    var images = [];
    if (imgSrc) {
      try {
        images = typeof imgSrc === "string" ? JSON.parse(imgSrc) : imgSrc;
      } catch (e) {
        var str = String(imgSrc);
        var sep = str.indexOf(";") !== -1 ? ";" : ",";
        images = $.map(str.split(sep), function (s) { return s.trim() || null; });
      }
    }
    if (!Array.isArray(images)) images = [];
    images = $.map(images, function (img) {
      var url = typeof img === "string" ? img : (img.src || img.thumbnail || img.url || img.image || "");
      return /\.(heic|heif)$/i.test(url) ? null : (url || null);
    });
    return images;
  }

  function getVideos(r) {
    var vidSrc = r.published_videos || r.unpublished_videos || "";
    var videos = [];
    if (vidSrc) {
      try {
        videos = typeof vidSrc === "string" ? JSON.parse(vidSrc) : vidSrc;
      } catch (e) {
        var str = String(vidSrc);
        var sep = str.indexOf(";") !== -1 ? ";" : ",";
        videos = $.map(str.split(sep), function (s) { return s.trim() || null; });
      }
    }
    if (!Array.isArray(videos)) videos = [];
    return $.map(videos, function (vid) {
      var url = typeof vid === "string" ? vid : (vid.src || vid.url || vid.video || "");
      return url || null;
    });
  }

  function getMediaItems(r) {
    var items = [];
    $.each(getImages(r), function (_, url) { items.push({ type: "image", url: url }); });
    $.each(getVideos(r), function (_, url) { items.push({ type: "video", url: url }); });
    return items;
  }

  var LANG_TO_COUNTRY = {
    af:"Afghanistan",sq:"Albania",dz:"Algeria",ar:"Arabic",am:"Armenia",
    az:"Azerbaijan",eu:"Basque",be:"Belarus",bn:"Bangladesh",bs:"Bosnia",
    bg:"Bulgaria",ca:"Catalonia",zh:"China",hr:"Croatia",cs:"Czech Republic",
    da:"Denmark",nl:"Netherlands",en:"United Kingdom",et:"Estonia",fi:"Finland",
    fr:"France",ka:"Georgia",de:"Germany",el:"Greece",gu:"India",he:"Israel",
    hi:"India",hu:"Hungary",is:"Iceland",id:"Indonesia",it:"Italy",ja:"Japan",
    kn:"India",kk:"Kazakhstan",ko:"Korea",lv:"Latvia",lt:"Lithuania",
    mk:"North Macedonia",ms:"Malaysia",mr:"India",no:"Norway",pl:"Poland",
    pt:"Portugal",ro:"Romania",ru:"Russia",sr:"Serbia",sk:"Slovakia",
    sl:"Slovenia",es:"Spain",sv:"Sweden",ta:"India",te:"India",th:"Thailand",
    tr:"Turkey",uk:"Ukraine",ur:"Pakistan",vi:"Vietnam",
  };

  function langToCountry(code) {
    if (!code) return "";
    return LANG_TO_COUNTRY[code.toLowerCase()] || "";
  }

  function isAlreadyInTargetLang(location) {
    if (!location) return false;
    var match = location.match(/,\s*([A-Za-z]{2})\s*$/);
    return match ? match[1].toLowerCase() === lang : false;
  }

  function reviewNeedsTranslate(reviewLang, location) {
    if (reviewLang) return reviewLang.toLowerCase() !== langNeeded;
    return !isAlreadyInTargetLang(location);
  }

  function baseParams(rating) {
    var p = "&product_lookup=eq." + productGroup;
    if (rating && rating !== "all") p += "&rating=eq." + rating;
    return p;
  }

  function fetchCount(rating) {
    var url =
      SUPABASE_URL +
      "/rest/v1/" +
      encodeURIComponent("Reviews.io Original data") +
      "?select=rating" +
      baseParams(rating) +
      "&limit=1";
    return $.ajax({
      url: url,
      headers: $.extend({}, SUPABASE_HEADERS, { Prefer: "count=exact" }),
    }).then(function (_data, _status, xhr) {
      var range = xhr.getResponseHeader("Content-Range");
      return range ? parseInt(range.split("/")[1], 10) || 0 : 0;
    });
  }

  function fetchPage(rating, page) {
    var offset = (page - 1) * PAGE_SIZE;
    var url =
      SUPABASE_URL +
      "/rest/v1/" +
      encodeURIComponent("Reviews.io Original data") +
      "?select=id,review_title,comments,rating,date_created,author,location,votes,unpublished_images,published_images,language," + TRANS_TITLE + "," + TRANS_TEXT +
      baseParams(rating) +
      "&order=" + (SORT_ORDER[currentSort] || "date_created.desc") +
      "&limit=" + PAGE_SIZE +
      "&offset=" + offset;
    return $.ajax({ url: url, headers: SUPABASE_HEADERS });
  }

  function fetchGalleryReviews() {
    var url =
      SUPABASE_URL +
      "/rest/v1/" +
      encodeURIComponent("Reviews.io Original data") +
      "?select=id,votes,review_title,comments,rating,date_created,author,location,published_images,unpublished_images,published_videos,unpublished_videos,language," + TRANS_TITLE + "," + TRANS_TEXT +
      "&product_lookup=eq." + productGroup +
      "&or=(published_images.not.is.null,unpublished_images.not.is.null,published_videos.not.is.null,unpublished_videos.not.is.null)" +
      "&order=date_created.desc" +
      "&limit=50";
    return $.ajax({ url: url, headers: SUPABASE_HEADERS });
  }

  function getVotedSet() {
    var match = document.cookie.match(/(?:^|;\s*)sr_votes=([^;]*)/);
    return match ? new Set(match[1].split(",").filter(Boolean)) : new Set();
  }

  function markVoted(id) {
    var set = getVotedSet();
    set.add(String(id));
    var expires = new Date(Date.now() + 365 * 86400 * 1000).toUTCString();
    document.cookie = "sr_votes=" + Array.from(set).join(",") + "; expires=" + expires + "; path=/";
  }

  function renderReview(r) {
    var rating = Math.min(Math.max(Math.round(r.rating) || 0, 1), 5);
    var date = timeAgo(r.date_created);
    var images = getImages(r);

    var starsHtml =
      '<img loading="lazy" class="pdp_supa-review-stars" data="' + rating + '" src="' + STAR_IMGS[rating] + '">';

    var mediaHtml = images.length
      ? $.map(images.slice(0, 5), function (img) {
          return '<img loading="lazy" src="' + img + '" alt="">';
        }).join("")
      : "";

    return (
      '<div class="pdp_supa-review" data-rating="' + rating + '" data-language="' + escapeAttr(r.language || "") + '" data-review-id="' + escapeAttr(r.id || "") + '">' +
        '<div class="pdp_supa-review-info">' +
          '<div>' +
          '<p class="pdp_supa-review-verif">' +
            '<span><img src="' + BADGE_ICON + '" alt="badge icon"></span>' +
            '<span>' + VERIFIED_BUYER + '</span>' +
          "</p>" +
          '<p class="pdp_supa-review-name">' + (r.author || "") + "</p>" +
          (function(){ var country = r.location || langToCountry(r.language); return country ? '<p class="pdp_supa-review-country">' + country + "</p>" : ""; }()) +
          '</div>' +
          '<div class="Mobile_only">' +
            '<div class="Mobile_only pdp_supa-stars__mobile">'+ starsHtml +'</div>' +
            (date ? '<p class="pdp_supa-review-date Mobile_only">' + date + "</p>" : "") +
          '</div>' +
        "</div>" +
        '<div class="pdp_supa-review-content">' +
          '<div class="Desktop_only">' +
            starsHtml +
          '</div>' +
          (r[TRANS_TITLE] || r.review_title ? '<p class="pdp_supa-review-title translatedCont">' + (r[TRANS_TITLE] || r.review_title) + "</p>" : "") +
          (r[TRANS_TEXT] || r.comments || !(r.review_title || r[TRANS_TITLE])
            ? '<div class="pdp_supa-review-text translatedCont"><p>' + (r[TRANS_TEXT] || r.comments || NO_COMMENTS) + "</p></div>"
            : "") +
          (r[TRANS_TITLE] ? (r.review_title ? '<p class="pdp_supa-review-title originalCont">' + r.review_title + "</p>" : "") : "") +
          (r[TRANS_TEXT]  ? '<div class="pdp_supa-review-text originalCont"><p>' + (r.comments || "") + "</p></div>" : "") +
          (r.comments || r[TRANS_TEXT] || r[TRANS_TITLE] ? (reviewNeedsTranslate(r.language, r.location) ? TRANSLATE_BTNS_HTML : "") : "") +
          '<div class="pdp_supa-reviews-media">' + mediaHtml + "</div>" +
          '<div class="pdp_supa-review-footer">' +
            "<div>" +
              (date ? '<p class="pdp_supa-review-date Desktop_only">' + date + "</p>" : "") +
            "</div>" +
            "<div>" +
              (function() {
                var voted = getVotedSet().has(String(r.id));
                return '<div class="pdp_supa-review-social' + (voted ? " voted" : "") + '">' +
                  "<div><p>" + (voted ? UPVOTED : WAS_HELPFUL) + "</p></div>" +
                  '<div class="pdp_supa-review-rate-review" data-review-id="' + r.id + '">' +
                    '<span><img src="https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Icon_2_d7f6aeb9-0636-45d8-b370-1899b26f3637.png?v=1757407762"></span>' +
                    "<span>" + (r.votes || 0) + "</span>" +
                  "</div>" +
                "</div>";
              })() +
            "</div>" +
          "</div>" +
        "</div>" +
      "</div>"
    );
  }

  function renderGallery(reviews) {
    galleryReviews = reviews;
    var $container = $(".pdp_supa-reviews-gallery");
    if (!$container.length) return;

    var cells = [];
    $.each(reviews, function (idx, r) {
      var items = getMediaItems(r);
      if (!items.length) return;

      var first  = items[0];
      var date   = timeAgo(r.date_created);
      var rating = Math.min(Math.max(Math.round(r.rating) || 0, 1), 5);

      var thumbHtml = first.type === "video"
        ? '<div class="pdp-gallery-video-thumb">' +
            '<video class="pdp-gallery-video-el" src="' + first.url + '" muted preload="metadata" playsinline></video>' +
            '<div class="pdp-gallery-play-icon">' + PLAY_ICON_SVG + '</div>' +
          '</div>'
        : '<img src="' + thumbUrl(first.url) + '" alt="" onerror="$(this).closest(\'.pdp_supa-reviews-gallery-cell\').hide()">';

      cells.push(
        '<div class="pdp_supa-reviews-gallery-cell"' +
          ' data-gallery-index="' + idx + '"' +
          ' data-name="'        + escapeAttr(r.author)            + '"' +
          ' data-title="'       + escapeAttr(r.review_title)      + '"' +
          ' data-text="'        + escapeAttr(r.comments)          + '"' +
          ' data-trans-text="'  + escapeAttr(r[TRANS_TEXT] || "") + '"' +
          ' data-trans-title="' + escapeAttr(r[TRANS_TITLE] || "") + '"' +
          ' data-date="'        + escapeAttr(date)                + '"' +
          ' data-city="'        + escapeAttr(r.location)          + '"' +
          ' data-language="'    + escapeAttr(r.language || "")    + '"' +
          ' data-rating="'      + rating                          + '"' +
          ' data-media="'       + escapeAttr(JSON.stringify(items)) + '">' +
          thumbHtml +
        "</div>"
      );
    });

    $container.html(cells.join(""));
    $(".pdp_supa-reviews-gallery-slider").toggle(cells.length > 0);
    initGalleryVideoThumbs();
    gallerySliderIndex = 0;
    setTimeout(updateGalleryArrows, 100);
  }

  function initGalleryVideoThumbs() {
    $(".pdp-gallery-video-el").each(function () {
      var v = this;
      if (v.readyState >= 1) {
        v.currentTime = 0.001;
      } else {
        $(v).on("loadedmetadata.galleryThumb", function () {
          v.currentTime = 0.001;
          $(v).off("loadedmetadata.galleryThumb");
        });
      }
    });
  }

  function updateGalleryArrows() {
    var $wrapper  = $(".pdp_supa-reviews-gallery-wrapper");
    if (!$wrapper.length) return;
    var scrollLeft = $wrapper.scrollLeft();
    var maxScroll  = $wrapper[0].scrollWidth - $wrapper[0].clientWidth;
    var noOverflow = maxScroll <= 0;
    $wrapper.toggleClass("fullwidth", noOverflow);
    $(".pdp_supa-reviews-nav.prevArr, .pdp_supa-reviews-nav.nextArr").toggle(!noOverflow);
    if (!noOverflow) {
      $(".pdp_supa-reviews-nav.prevArr").toggleClass("disabledsup", scrollLeft <= 0);
      $(".pdp_supa-reviews-nav.nextArr").toggleClass("disabledsup", scrollLeft >= maxScroll - 1);
    }
  }

  function scrollGalleryToIndex(index) {
    var $wrapper = $(".pdp_supa-reviews-gallery-wrapper");
    var $cells   = $(".pdp_supa-reviews-gallery-cell");
    if (!$wrapper.length || !$cells.length) return;
    index = Math.max(0, Math.min(index, $cells.length - 1));
    gallerySliderIndex = index;
    var cellLeft = $cells.eq(index).offset().left - $wrapper.offset().left + $wrapper.scrollLeft();
    $wrapper[0].scrollLeft = cellLeft;
  }

  function getPageNumbers(current, total) {
    if (total <= 10) {
      var all = [];
      for (var i = 1; i <= total; i++) all.push(i);
      return all;
    }
    var winStart = Math.max(1, current - 3);
    var winEnd   = Math.min(total, current + 3);
    if (winEnd - winStart < 6) {
      if (winStart === 1) winEnd = Math.min(total, 7);
      else if (winEnd === total) winStart = Math.max(1, total - 6);
    }
    var pages = [];
    if (winStart > 1) {
      pages.push(1);
      if (winStart > 2) pages.push("...");
    }
    for (var i = winStart; i <= winEnd; i++) pages.push(i);
    if (winEnd < total) {
      if (winEnd < total - 1) pages.push("...");
      pages.push(total);
    }
    return pages;
  }

  function renderPagination() {
    var $el = $("#supra-reviews-pagination");
    if (!$el.length) return;
    if (totalPages <= 1) { $el.html(""); return; }

    var html = "";
    $.each(getPageNumbers(currentPage, totalPages), function (_, p) {
      if (p === "...") {
        html += '<span class="supra-page-ellipsis">…</span>';
      } else {
        html +=
          '<button class="supra-page-btn' + (p === currentPage ? " active" : "") + '" data-page="' + p + '">' + p + "</button>";
      }
    });
    $el.html(html);
  }

  function renderReviews(reviews) {
    var $container = $("#supa-reviews-list");
    if (!$container.length) return;
    $container.html(reviews && reviews.length ? $.map(reviews, renderReview).join("") : "");
  }

  function goToPage(page) {
    currentPage = page;
    renderPagination();
    fetchPage(currentRating, page).then(function (reviews) {
      renderReviews(reviews);
      var $el = $(".pdp_supa-reviews");
      if ($el.length) {
        $("html, body").animate({ scrollTop: $el.offset().top - 200 }, 300);
      }
    });
  }

  function loadReviews(rating) {
    currentRating = rating;
    currentPage = 1;
    fetchCount(rating)
      .then(function (total) {
        totalPages = Math.ceil(total / PAGE_SIZE) || 1;
        renderPagination();
        return fetchPage(rating, 1);
      })
      .then(renderReviews);
  }

  function initRatingCounts() {
    $.each(["all", "5", "4", "3", "2", "1"], function (_, rating) {
      fetchCount(rating).then(function (count) {
        var $line = $(".overall-rating_filter_line[data='" + rating + "']");
        $line.find(".overall-rating_info__count").text(count);
        if (count === 0) $line.addClass("disabled");
        if (rating === "all") {
          var countLabel = (window.reviewStrings && window.reviewStrings.countLabel) || $(".reviews-pdp-dynamic-copies").data("count-label") || "";
          var countText = countLabel ? countLabel.replace("[count]", count) : count;
          $(".main_product_rating_actual__js").each(function () {
            $(this).html($(this).hasClass("main_pdp-reviews") ? "(" + countText + ")" : countText);
          });
          $(".main_product_rating_actual__js_carted").html("(" + countText + ")");
          $(".product-overall_rating-stars").find("p span").html(count);
        }
      });
    });
  }

  function initFilters() {
    $(document).on("click", ".overall-rating_filter_line", function () {
      if ($(this).hasClass("disabled")) return;
      $(".overall-rating_filter_line").removeClass("active");
      $(this).addClass("active");
      loadReviews($(this).attr("data"));
    });

  }

  $(document).on("click", ".supra-page-btn", function () {
    goToPage(parseInt($(this).attr("data-page"), 10));
  });

  // ── Gallery slider arrows ──────────────────────────────────────────────────

  $(document).on("click", ".pdp_supa-reviews-nav.nextArr", function () {
    if ($(this).hasClass("disabledsup")) return;
    scrollGalleryToIndex(gallerySliderIndex + 1);
  });

  $(document).on("click", ".pdp_supa-reviews-nav.prevArr", function () {
    if ($(this).hasClass("disabledsup")) return;
    scrollGalleryToIndex(gallerySliderIndex - 1);
  });

  // ── Translate / revert buttons ─────────────────────────────────────────────

  $(document).on("click", ".rsp_popup-translate-btn", function () {
    var $btn       = $(this);
    var $btns      = $btn.closest(".rsp_popup-translate_btns");
    var $container = $btn.closest(".pdp_supa-review, .rsp-popup_review_content");
    $btn.hide();
    $btns.find(".rsp_popup-loading-btn").css({ display: "block", opacity: "1" });
    setTimeout(function () {
      $btns.find(".rsp_popup-loading-btn").hide();
      $btns.find(".rsp_popup-revert-btn").css("display", "inline-block");
      $container.find(".originalCont").hide();
      $container.find(".translatedCont").show();
    }, 1000);
  });

  $(document).on("click", ".rsp_popup-revert-btn", function () {
    var $btn       = $(this);
    var $btns      = $btn.closest(".rsp_popup-translate_btns");
    var $container = $btn.closest(".pdp_supa-review, .rsp-popup_review_content");
    $btn.hide();
    $btns.find(".rsp_popup-loading-btn").css({ display: "block", opacity: "1" });
    setTimeout(function () {
      $btns.find(".rsp_popup-loading-btn").hide();
      $btns.find(".rsp_popup-translate-btn").css("display", "inline-block");
      $container.find(".translatedCont").hide();
      $container.find(".originalCont").show();
    }, 1000);
  });

  function renderPopupContent(data) {
    var origText  = data.origText  || "";
    var transText = data.transText || "";
    var loc       = data.city || data.location || "";
    var html      = "";
    if (transText) {
      html += '<p class="translatedCont">' + transText + "</p>";
      html += '<p class="originalCont">' + origText + "</p>";
    } else {
      html += "<p>" + origText + "</p>";
    }
    if (transText && reviewNeedsTranslate(data.language || "", loc)) {
      html += TRANSLATE_BTNS_HTML;
    }
    return html;
  }

  // ── Popup ──────────────────────────────────────────────────────────────────

  var galleryReviews     = [];
  var galleryReviewIndex = -1;
  var gallerySliderIndex  = 0;
  var popupMedia          = [];
  var popupIndex          = 0;
  var popupImageGen       = 0;
  var thumbsScrollTarget  = 0;
  var popupReviewId       = null;
  var popupReviewVotes    = 0;

  function updateMainArrows() {
    var $popup = $(".rsp_popup-outer");
    if (!$popup.length) return;

    var hasGalleryItems = nextReviewWithMedia(0) !== -1;
    var hasPrevReview = galleryReviewIndex >= 0 ? prevReviewWithMedia(galleryReviewIndex - 1) !== -1 : hasGalleryItems;
    var hasNextReview = galleryReviewIndex >= 0 ? nextReviewWithMedia(galleryReviewIndex + 1) !== -1 : hasGalleryItems;
    var canNavigate   = popupMedia.length > 1 || hasPrevReview || hasNextReview;
    $popup.find(".rsp_popup-media-arrow__left").toggle(popupMedia.length > 0 && canNavigate);
    $popup.find(".rsp_popup-media-arrow__right").toggle(popupMedia.length > 0 && canNavigate);

    var reviewsWithMedia = 0;
    $.each(galleryReviews, function (_, r) { if (getMediaItems(r).length) reviewsWithMedia++; });
    $popup.find(".rsp_popup-thumbs-arrow__left, .rsp_popup-thumbs-arrow__right").toggle(reviewsWithMedia > 1);
  }

  function setPopupImage(index) {
    var $popup = $(".rsp_popup-outer");
    if (!$popup.length) return;

    var $existingVideo = $popup.find(".rsp_popup-video-el");
    if ($existingVideo.length) {
      $existingVideo[0].pause();
      $existingVideo[0].currentTime = 0;
      $existingVideo.prop("muted", true).removeAttr("controls");
      $popup.find(".rsp_popup-video-wrap").hide().removeClass("playing");
      $popup.find(".rsp_popup-video-play-btn").show();
    }

    popupIndex = index;
    var item = popupMedia[index];
    if (!item) return;

    if (item.type === "video") {
      if (!$popup.find(".rsp_popup-video-wrap").length) {
        $popup.find(".rsp_popup-main-image__src").after(
          '<div class="rsp_popup-video-wrap">' +
            '<video class="rsp_popup-video-el" preload="metadata" muted playsinline></video>' +
            '<div class="rsp_popup-video-play-btn">' + POPUP_PLAY_ICON_SVG + '</div>' +
          '</div>'
        );
      }
      var $videoWrap = $popup.find(".rsp_popup-video-wrap");
      var $videoEl   = $videoWrap.find(".rsp_popup-video-el");
      $popup.find(".rsp_popup-main-image__src").css("visibility", "hidden");
      $videoWrap.css("display", "flex").removeClass("playing");
      $videoWrap.find(".rsp_popup-video-play-btn").show();
      $videoEl.attr("src", item.url).prop("muted", true).removeAttr("controls");
      $videoEl[0].load();
      $videoEl[0].currentTime = 0.001;
    } else {
      $popup.find(".rsp_popup-video-wrap").hide();
      var $img = $popup.find(".rsp_popup-main-image__src");
      $img.css("visibility", "").attr("src", thumbUrl(item.url)).addClass("loadingImage");
      var myGen = ++popupImageGen;
      var hi = new Image();
      hi.onload = function () {
        if (popupImageGen !== myGen) return;
        $img.attr("src", item.url).removeClass("loadingImage");
      };
      hi.src = item.url;
    }

    var hasGalleryItems = nextReviewWithMedia(0) !== -1;
    var hasPrev = galleryReviewIndex > 0 ? prevReviewWithMedia(galleryReviewIndex - 1) !== -1 : (galleryReviewIndex < 0 && hasGalleryItems);
    var hasNext = galleryReviewIndex >= 0 ? nextReviewWithMedia(galleryReviewIndex + 1) !== -1 : hasGalleryItems;
    $popup.find(".rsp_popup-media-arrow__left").toggleClass("disabledArrowMain", index <= 0 && !hasPrev);
    $popup.find(".rsp_popup-media-arrow__right").toggleClass("disabledArrowMain", index >= popupMedia.length - 1 && !hasNext);
  }

  function buildPopupGallery(activeIndex) {
    var $popup = $(".rsp_popup-outer");
    if (!$popup.length) return;
    var $strip = $popup.find(".rsp_popup-thumbnails_gallery");
    if (!$strip.length) return;

    $strip.html(
      $.map(galleryReviews, function (r, i) {
        var items = getMediaItems(r);
        if (!items.length) return null;
        var first = items[0];
        var thumbContent = first.type === "video"
          ? '<div class="rsp_popup-gallery-video-thumb">' +
              '<video src="' + first.url + '" muted preload="metadata" playsinline></video>' +
              '<div class="rsp_popup-gallery-play-icon">' + PLAY_ICON_SVG + '</div>' +
            '</div>'
          : '<img src="' + thumbUrl(first.url) + '" alt="">';
        return (
          '<div class="rsp_popup-gallery-review' + (i === activeIndex ? " active" : "") + '" data-gallery-index="' + i + '">' +
            thumbContent +
          "</div>"
        );
      }).join("")
    );

    $strip.find("video").each(function () {
      var v = this;
      if (v.readyState >= 1) {
        v.currentTime = 0.001;
      } else {
        $(v).on("loadedmetadata", function () { v.currentTime = 0.001; });
      }
    });
  }

  function setPopupReview(index, goToLast) {
    if (index < 0 || index >= galleryReviews.length) return;
    var r = galleryReviews[index];
    var items = getMediaItems(r);
    if (!items.length) return;

    galleryReviewIndex = index;
    popupMedia = items;
    popupReviewId    = r.id    != null ? String(r.id)            : null;
    popupReviewVotes = r.votes != null ? parseInt(r.votes, 10)   : 0;

    var $popup = $(".rsp_popup-outer");
    if (!$popup.length) return;
    $popup.find(".rsp_popup-main-image__src").addClass("loadingImage");

    var rating = Math.min(Math.max(Math.round(r.rating) || 0, 1), 5);
    $popup.find(".rsp_popup-days").text(timeAgo(r.date_created) || "");
    $popup.find(".rsp_popup-name").text(r.author || "");
    $popup.find(".rsp-popup_review_content").html(renderPopupContent({
      origText:   r.comments     || "",
      transText:  r[TRANS_TEXT]  || "",
      origTitle:  r.review_title || "",
      transTitle: r[TRANS_TITLE] || "",
      city:       r.location     || "",
      language:   r.language     || "",
    }));
    $popup.find(".rsp-popup_stars").html(
      STAR_IMGS[rating] ? '<img src="' + STAR_IMGS[rating] + '" alt="">' : ""
    );

    $popup.find(".rsp_popup-gallery-review").each(function () {
      var cellIndex = parseInt($(this).attr("data-gallery-index"), 10);
      $(this).toggleClass("active", cellIndex === index);
      if (cellIndex === index) {
        var outer = $(this).closest(".rsp_popup-thumbnails_gallery--outer")[0];
        if (outer) {
          outer.scrollLeft = this.offsetLeft - outer.offsetWidth / 2 + this.offsetWidth / 2;
        }
      }
    });

    setPopupImage(goToLast ? items.length - 1 : 0);
    updateMainArrows();
    updateHelpfulBtn();
  }

  function closePopup() {
    var $p = $(".rsp_popup-outer");
    if (!$p.length) return;
    var $videoEl = $p.find(".rsp_popup-video-el");
    if ($videoEl.length) {
      $videoEl[0].pause();
      $videoEl[0].currentTime = 0;
      $videoEl.prop("muted", true).removeAttr("controls");
      $p.find(".rsp_popup-video-wrap").hide().removeClass("playing");
      $p.find(".rsp_popup-video-play-btn").show();
    }
    $p.find(".rsp_popup-main-image__src").css("visibility", "");
    $p.hide();
    setTimeout(function () { document.body.style.removeProperty("overflow"); }, 0);
    $p.find(".rsp_popup-review-info").removeClass("loaded");
    $p.removeAttr("data-supa-source");
  }

  function openPopup(media, startIndex, meta, reviewIndex) {
    var $popup = $(".rsp_popup-outer");
    if (!$popup.length) return;
    document.body.style.setProperty("overflow", "hidden");
    $popup.find(".rsp_popup-main-image__src").addClass("loadingImage");

    popupMedia = media;
    galleryReviewIndex = reviewIndex !== undefined ? reviewIndex : -1;
    popupReviewId    = meta.id    != null ? String(meta.id)          : null;
    popupReviewVotes = meta.votes != null ? parseInt(meta.votes, 10) : 0;
    if (popupReviewId === null && galleryReviewIndex >= 0 && galleryReviews[galleryReviewIndex]) {
      var gr = galleryReviews[galleryReviewIndex];
      popupReviewId    = gr.id    != null ? String(gr.id)    : null;
      popupReviewVotes = parseInt(gr.votes, 10) || 0;
    }

    $popup.find(".rsp_popup-days").text(meta.date || "");
    $popup.find(".rsp_popup-name").text(meta.name || "");
    $popup.find(".rsp-popup_review_content").html(renderPopupContent({
      origText:   meta.origText   || meta.text || "",
      transText:  meta.transText  || "",
      origTitle:  meta.origTitle  || "",
      transTitle: meta.transTitle || "",
      city:       meta.city       || "",
      language:   meta.language   || "",
    }));
    $popup.find(".rsp-popup_stars").html(
      meta.rating && STAR_IMGS[meta.rating] ? '<img src="' + STAR_IMGS[meta.rating] + '" alt="">' : ""
    );

    thumbsScrollTarget = 0;
    buildPopupGallery(galleryReviewIndex);
    setPopupImage(startIndex);
    updateMainArrows();
    updateHelpfulBtn();

    $popup.attr("data-supa-source", "true");
    $popup.find(".rsp_popup-review-info").removeClass("loaded");
    $popup.css("display", "flex");
    setTimeout(function () {
      $popup.find(".rsp_popup-review-info").addClass("loaded");
    }, 200);
  }

  function nextReviewWithMedia(fromIndex) {
    for (var i = fromIndex; i < galleryReviews.length; i++) {
      if (getMediaItems(galleryReviews[i]).length) return i;
    }
    return -1;
  }

  function prevReviewWithMedia(fromIndex) {
    for (var i = fromIndex; i >= 0; i--) {
      if (getMediaItems(galleryReviews[i]).length) return i;
    }
    return -1;
  }

  function updateHelpfulBtn() {
    var $popup = $(".rsp_popup-outer");
    if (!$popup.length) return;
    var voted = !!(popupReviewId && getVotedSet().has(String(popupReviewId)));
    $popup.find(".rsp-popup_helpful").toggleClass("voted", voted);
    $popup.find(".rsp-popup_helpful-btn").toggleClass("liked", voted);
  }

  function initPopup() {
    if (!$(".rsp_popup-outer").length) return;

    $(document).on("click", ".rsp_popup-media-arrow__right", function () {
      if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
      if ($(this).hasClass("disabledArrowMain")) return;
      if (popupIndex < popupMedia.length - 1) {
        setPopupImage(popupIndex + 1);
      } else {
        var next = galleryReviewIndex >= 0
          ? nextReviewWithMedia(galleryReviewIndex + 1)
          : nextReviewWithMedia(0);
        if (next !== -1) setPopupReview(next);
      }
    });

    $(document).on("click", ".rsp_popup-media-arrow__left", function () {
      if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
      if ($(this).hasClass("disabledArrowMain")) return;
      if (popupIndex > 0) {
        setPopupImage(popupIndex - 1);
      } else {
        var prev = galleryReviewIndex >= 0
          ? prevReviewWithMedia(galleryReviewIndex - 1)
          : prevReviewWithMedia(galleryReviews.length - 1);
        if (prev !== -1) setPopupReview(prev, true);
      }
    });

    $(document).on("click", ".rsp_popup-thumbs-arrow__right", function () {
      if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
      var outer = $(".rsp_popup-thumbnails_gallery--outer")[0];
      if (!outer) return;
      thumbsScrollTarget = Math.min(thumbsScrollTarget + 184, outer.scrollWidth - outer.clientWidth);
      outer.scrollLeft = thumbsScrollTarget;
    });

    $(document).on("click", ".rsp_popup-thumbs-arrow__left", function () {
      if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
      var outer = $(".rsp_popup-thumbnails_gallery--outer")[0];
      if (!outer) return;
      thumbsScrollTarget = Math.max(thumbsScrollTarget - 184, 0);
      outer.scrollLeft = thumbsScrollTarget;
    });

    $(document).on("click", ".rsp_popup-gallery-review", function () {
      if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
      setPopupReview(parseInt($(this).attr("data-gallery-index"), 10));
    });

    $(document).on("click", ".rsp_popup-close", function () {
      closePopup();
    });

    $(document).on("click", ".rsp_popup-outer", function (e) {
      if (!$(e.target).closest(".rsp_popup-inner").length) {
        e.stopImmediatePropagation();
        closePopup();
      }
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape") closePopup();
    });

    $(document).on("click", ".R-MediaSlider__item--reviewPhoto, .R-PhotoVideoThumbnail", function () {
      $(".rsp_popup-outer").removeAttr("data-supa-source");
    });

    $(document).on("click", ".rsp-popup_helpful-btn", function () {
      if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
      var $helpful = $(this).closest(".rsp-popup_helpful");
      if ($helpful.hasClass("voted") || !popupReviewId) return;
      var id = popupReviewId;
      var newCount = popupReviewVotes + 1;
      $.ajax({
        url: SUPABASE_URL + "/rest/v1/" + encodeURIComponent("Reviews.io Original data") + "?id=eq." + id,
        method: "PATCH",
        headers: $.extend({}, SUPABASE_HEADERS, { Prefer: "return=minimal" }),
        contentType: "application/json",
        data: JSON.stringify({ votes: newCount }),
      }).done(function () {
        markVoted(id);
        popupReviewVotes = newCount;
        $helpful.addClass("voted");
        var $card = $(".pdp_supa-review-rate-review[data-review-id='" + id + "']");
        if ($card.length) {
          $card.find("span:last").text(newCount);
          $card.closest(".pdp_supa-review-social").addClass("voted").find("div:first p").text(UPVOTED);
        }
      });
    });

    $(document).on("click", ".pdp_supa-reviews-gallery-cell", function () {
      var $cell = $(this);
      var media = [];
      try { media = JSON.parse($cell.attr("data-media") || "[]"); } catch (_) {}
      var gIdx = parseInt($cell.attr("data-gallery-index"), 10);
      openPopup(media, 0, {
        name:       $cell.attr("data-name")        || "",
        date:       $cell.attr("data-date")        || "",
        text:       $cell.attr("data-text")        || "",
        origText:   $cell.attr("data-text")        || "",
        transText:  $cell.attr("data-trans-text")  || "",
        transTitle: $cell.attr("data-trans-title") || "",
        city:       $cell.attr("data-city")        || "",
        language:   $cell.attr("data-language")    || "",
        rating:     parseInt($cell.attr("data-rating"), 10) || 0,
      }, isNaN(gIdx) ? -1 : gIdx);
    });

    $(document).on("click", ".rsp_popup-video-play-btn", function () {
      if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
      var $wrap = $(this).closest(".rsp_popup-video-wrap");
      var video = $wrap.find(".rsp_popup-video-el")[0];
      if (!video) return;
      $(this).hide();
      $wrap.addClass("playing");
      video.muted = false;
      video.currentTime = 0;
      video.setAttribute("controls", "");
      video.play();
    });

    $(document).on("click", ".pdp_supa-reviews-media img", function () {
      var $img    = $(this);
      var $media  = $img.closest(".pdp_supa-reviews-media");
      var $all    = $media.find("img");
      var media   = $all.map(function () { return { type: "image", url: this.src }; }).get();
      var idx     = $all.index($img);
      var $review = $img.closest(".pdp_supa-review");
      var reviewId = $review.attr("data-review-id");
      var gIdx = -1;
      if (reviewId) {
        $.each(galleryReviews, function (i, r) {
          if (String(r.id) === String(reviewId)) { gIdx = i; return false; }
        });
      }
      var $origTextEl   = $review.find(".pdp_supa-review-text.originalCont p");
      var $transTextEl  = $review.find(".pdp_supa-review-text.translatedCont p");
      var $origTitleEl  = $review.find(".pdp_supa-review-title.originalCont");
      var $transTitleEl = $review.find(".pdp_supa-review-title.translatedCont");
      openPopup(media, idx < 0 ? 0 : idx, {
        name:       $review.find(".pdp_supa-review-name").text().trim(),
        date:       $review.find(".pdp_supa-review-date").text().trim(),
        origText:   $origTextEl.length  ? $origTextEl.text().trim()  : $transTextEl.text().trim(),
        transText:  $origTextEl.length  ? $transTextEl.text().trim() : "",
        origTitle:  $origTitleEl.length ? $origTitleEl.text().trim() : $transTitleEl.text().trim(),
        transTitle: $origTitleEl.length ? $transTitleEl.text().trim() : "",
        city:       $review.find(".pdp_supa-review-country").text().trim(),
        language:   $review.attr("data-language") || "",
        rating:     parseInt($review.attr("data-rating"), 10) || 0,
        id:         reviewId || "",
        votes:      parseInt($review.find(".pdp_supa-review-rate-review span:last").text(), 10) || 0,
      }, gIdx);
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  if ($("#supa-reviews-list").length) {
    $('<div id="supra-reviews-pagination" class="supra-reviews-pagination">').insertAfter("#supa-reviews-list");
  }

  var galleryScrollTimer;
  $(".pdp_supa-reviews-gallery-wrapper").on("scroll", function () {
    clearTimeout(galleryScrollTimer);
    var $wrapper = $(this);
    galleryScrollTimer = setTimeout(function () {
      var scrollLeft = $wrapper.scrollLeft();
      var $cells = $(".pdp_supa-reviews-gallery-cell");
      var closest = 0;
      var closestDist = Infinity;
      $cells.each(function (i) {
        var cellLeft = $(this).offset().left - $wrapper.offset().left + scrollLeft;
        var dist = Math.abs(cellLeft - scrollLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      gallerySliderIndex = closest;
      updateGalleryArrows();
    }, 50);
  });

  loadReviews("all");
  initFilters();
  initRatingCounts();
  initPopup();
  fetchGalleryReviews().then(renderGallery);


  var $sortBackdrop = $('<div id="pdp-sort-backdrop" style="position:fixed;top:0;left:0;width:100%;height:100%;z-index:8;"></div>');

  function closeSortDropdown() {
    $(".pdp_sr-sort").removeClass("active");
    $(".pdp_sr-content").slideUp();
    $sortBackdrop.detach();
  }

  $(document).on("click", ".pdp_sr-sort", function () {
    var opening = !$(this).hasClass("active");
    $(this).toggleClass("active");
    $(".pdp_sr-content").slideToggle();
    if (opening) {
      $sortBackdrop.appendTo("body").one("click", closeSortDropdown);
    } else {
      $sortBackdrop.detach();
    }
  });

  $(document).on("click", ".pdp_sr-val", function () {
    var val      = $(this).attr("data");
    var isActive = $(this).hasClass("active");

    $(document).off("click.sortClose");
    closeSortDropdown();

    console.log(val, 'VALUE BY WHAT IS SORTING');

    if (isActive) return;

    $(".pdp_sr-val").removeClass("active");
    $(this).addClass("active");
    $(".pdp_sr-sort span:first").text($(this).text().trim());

    currentSort = val;
    currentPage = 1;
    fetchPage(currentRating, 1).then(renderReviews);
  });

  $(document).on("click", ".pdp_supa-review-rate-review", function () {
    var $btn    = $(this);
    var reviewId = String($btn.attr("data-review-id"));
    var $social  = $btn.closest(".pdp_supa-review-social");

    if ($social.hasClass("voted")) return;

    var $countSpan = $btn.find("span:last");
    var newCount   = (parseInt($countSpan.text(), 10) || 0) + 1;

    $.ajax({
      url: SUPABASE_URL + "/rest/v1/" + encodeURIComponent("Reviews.io Original data") + "?id=eq." + reviewId,
      method: "PATCH",
      headers: $.extend({}, SUPABASE_HEADERS, { Prefer: "return=minimal" }),
      contentType: "application/json",
      data: JSON.stringify({ votes: newCount }),
    }).done(function () {
      markVoted(reviewId);
      $countSpan.text(newCount);
      $social.addClass("voted");
      $social.find("div:first p").text(UPVOTED);
    });
  });

});
